import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { TppClaimantsModel } from "../../models/tppclaimantsmodel";
import { environment } from '../../../environments/environment.prod';

const httpOptions = {
    headers: new HttpHeaders({ "Content-Type": "application/json" })
};

@Injectable({
    providedIn: "root"
})
export class TppClaimantService {
    baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }

  createClaimant(formData: FormData) {
    return this.http.post(
      this.baseUrl + "TppClaimants",
      formData
    );
  }

  //createClaimant(claimant: TppClaimantsModel): Observable<TppClaimantsModel> {
  //  return this.http.post<TppClaimantsModel>(this.baseUrl + "TppClaimants", claimant, httpOptions);
  //  }

  //  submitDocuments(claimNumber: string, files: File[]): Observable<any> {
  //    const docOptions = { headers: new HttpHeaders({ "Accept": "application/json" }), params: { claimnumber: claimNumber.toString() } }
  //    const formData = new FormData();
  //    if (files && files.length) {
  //      files.forEach(file => formData.append('files', file));
  //    }
  //    return this.http.post<any>(this.baseUrl + "TppClaimants/SubmitDocuments", formData, docOptions);
  //  }
}

